import { Part, TabTitle } from '@entities/Product';

export const filterTabsCard = (part, tabList, dataForCar) => {
  if ([Part.Oils, Part.RelatedProducts, Part.Secrets].includes(part as Part)) {
    return tabList.filter(
      button => button.title !== TabTitle.ProductReview && button.title !== TabTitle.HowToBuy && button.title !== TabTitle.Reviews,
    );
  } else if (part === Part.Disks) {
    return tabList.filter(button => {
      if (!Array.isArray(dataForCar)) {
        return button.title !== TabTitle.ProductReview;
      } else {
        return button.title !== TabTitle.ProductReview && button.title !== TabTitle.FitsTheCar;
      }
    });
  } else if (part === Part.Batteries) {
    return tabList.filter(button => button.title !== TabTitle.Reviews);
  } else if (part === Part.TruckTires) {
    return tabList.filter(button => button.title !== TabTitle.Reviews && button.title !== TabTitle.ProductReview);
  } else {
    return tabList;
  }
};
